import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';

export const ContactSection = ({ formData, handleInputChange, handleSubmit, isSubmitting }) => (
  <section id="contact" className="py-20 bg-zinc-900">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid md:grid-cols-2 gap-12">
        <div>
          <h3 className="text-red-600 font-bold text-sm uppercase tracking-wider mb-3">Contact Us</h3>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Get Your Free Estimate Today
          </h2>
          <p className="text-zinc-300 text-lg mb-8 leading-relaxed">
            Ready to start your fencing project? Fill out the form and we'll get back to you with a
            free, no-obligation estimate. We're here to answer your questions and help bring your project to life.
          </p>

          <div className="space-y-6">
            <div className="flex items-start space-x-4">
              <div className="w-12 h-12 bg-red-600 rounded-lg flex items-center justify-center flex-shrink-0">
                <Phone className="text-white" size={24} />
              </div>
              <div>
                <h4 className="text-white font-semibold mb-1">Phone</h4>
                <a href="tel:8177235006" className="text-zinc-300 hover:text-red-600 transition-colors">
                  817-723-5006
                </a>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="w-12 h-12 bg-red-600 rounded-lg flex items-center justify-center flex-shrink-0">
                <Mail className="text-white" size={24} />
              </div>
              <div>
                <h4 className="text-white font-semibold mb-1">Email</h4>
                <a href="mailto:Northtexasweldingandfab@gmail.com" className="text-zinc-300 hover:text-red-600 transition-colors break-all">
                  Northtexasweldingandfab@gmail.com
                </a>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="w-12 h-12 bg-red-600 rounded-lg flex items-center justify-center flex-shrink-0">
                <MapPin className="text-white" size={24} />
              </div>
              <div>
                <h4 className="text-white font-semibold mb-1">Service Area</h4>
                <p className="text-zinc-300">
                  Springtown, Weatherford, Azle, Decatur, Bridgeport, Fort Worth & Surrounding Areas
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-xl p-8 shadow-2xl">
          <form onSubmit={handleSubmit} className="space-y-6" data-testid="contact-form">
            <div>
              <label htmlFor="name" className="block text-sm font-semibold text-zinc-900 mb-2">
                Full Name *
              </label>
              <Input
                id="name"
                name="name"
                type="text"
                value={formData.name}
                onChange={handleInputChange}
                placeholder="John Doe"
                required
                className="w-full"
                data-testid="contact-name"
              />
            </div>

            <div>
              <label htmlFor="email" className="block text-sm font-semibold text-zinc-900 mb-2">
                Email Address
              </label>
              <Input
                id="email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="john@example.com"
                className="w-full"
                data-testid="contact-email"
              />
            </div>

            <div>
              <label htmlFor="phone" className="block text-sm font-semibold text-zinc-900 mb-2">
                Phone Number *
              </label>
              <Input
                id="phone"
                name="phone"
                type="tel"
                value={formData.phone}
                onChange={handleInputChange}
                placeholder="(817) 123-4567"
                required
                className="w-full"
                data-testid="contact-phone"
              />
            </div>

            <div>
              <label htmlFor="projectType" className="block text-sm font-semibold text-zinc-900 mb-2">
                Project Type
              </label>
              <Input
                id="projectType"
                name="projectType"
                type="text"
                value={formData.projectType}
                onChange={handleInputChange}
                placeholder="e.g., Pipe Fencing, Custom Gate"
                className="w-full"
                data-testid="contact-project-type"
              />
            </div>

            <div>
              <label htmlFor="address" className="block text-sm font-semibold text-zinc-900 mb-2">
                Project Location *
              </label>
              <Input
                id="address"
                name="address"
                type="text"
                value={formData.address}
                onChange={handleInputChange}
                placeholder="Street address, city, TX ZIP"
                required
                className="w-full"
                data-testid="contact-address"
              />
            </div>

            <div>
              <label htmlFor="message" className="block text-sm font-semibold text-zinc-900 mb-2">
                Project Details *
              </label>
              <Textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleInputChange}
                placeholder="Tell us about your fencing project..."
                rows={4}
                required
                className="w-full"
                data-testid="contact-message"
              />
            </div>

            <Button
              type="submit"
              disabled={isSubmitting}
              className="w-full bg-red-600 hover:bg-red-700 text-white font-semibold text-lg py-6"
              data-testid="contact-submit"
            >
              {isSubmitting ? 'Sending...' : 'Send Request'}
            </Button>
          </form>
        </div>
      </div>
    </div>
  </section>
);
